module.exports = __webpack_public_path__ + "media/assets/images/logo-light-972d9b1bf4ad9095a18851d36614476c.svg";